import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { BooleanTrueValues } from '../../../../enums/boolean-values.enum';

@Component({
  selector: 'boolean-cell-renderer',
  templateUrl: './boolean-cell-renderer.component.html',
  styleUrls: ['./boolean-cell-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BooleanCellRendererComponent implements ICellRendererAngularComp {
  value: boolean;
  iconName: string = '';

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  agInit(params: ICellRendererParams): void {
    this.updateValue(params.value);
  }

  refresh(params: ICellRendererParams): boolean {
    const newValue = this.checkForTrue(params.value);
    if (newValue !== this.value) {
      this.updateValue(params.value);
      this.changeDetectorRef.markForCheck();
      return true;
    }
    return false;
  }

  updateValue(value: any): void {
    this.value = this.checkForTrue(value);
    this.iconName = this.value ? 'checkmark' : 'close';
  }

  checkForTrue(value: any): boolean {
    if (typeof value === 'boolean') {
      return value;
    }
    const stringValue = value?.toString()?.toLowerCase();
    return (
      stringValue === BooleanTrueValues.true ||
      stringValue === BooleanTrueValues.one ||
      stringValue === BooleanTrueValues.on ||
      stringValue === BooleanTrueValues.yes ||
      stringValue === BooleanTrueValues.y ||
      stringValue === BooleanTrueValues.enabled ||
      stringValue === BooleanTrueValues.active
    );
  }
}
